import { front_api } from "./apiConfig";
import {
    getUsernameLocal, getUserIdFromLocal,
    getRoleId,
    savePermTree,
    saveSignaturePermTree,
    getSignaturePermTree
} from "../helpers/appHelpers";

// ------------------------------------- path -------------------------------------

// Get Details
const get_module_id = "/get_module/";
const get_module_sorted = "/get_module_sorted?module_id=";
const get_role_permission = "/get_role_permission";

// get list
const get_module_tree = "/get_module_tree";
const get_main_module_list = "/get_modules_main";
const get_all_roles = "/get_all_roles";

// Create || Add
const create_module = "/create_module";
const create_role = "/create_role";

// Edit || Update
const edit_module = "/edit_module/";
const upsert_role_permission = "/upsert_role_permission";

// Delete
const delete_module = "/delete_module/";

// ----------------------------------- services -----------------------------------

export const getModuleDetails = async (moduleId: any) => {
    const fullpath = get_module_id + moduleId;
    const body = {
        username: getUsernameLocal()
    };

    // logsPath("POST", fullpath);
    const response = await front_api("POST", fullpath, body, { wrapData: false });

    if (!response) return false;

    try {
        return await response.json();
    } catch (e) {
        console.error(e);
        return false;
    }
}

export const getSortOrder = async (moduleId: any) => {
    const fullpath = get_module_sorted + moduleId;

    // logsPath("GET", fullpath);
    const response = await front_api("GET", fullpath, {}, { wrapData: false });

    if (!response) return false;

    try {
        return await response.json();
    } catch (e) {
        console.error(e);
        return false;
    }
}

export const getRolePermission = async (role_id: any) => {
    const currentRoleId = getRoleId();
    const body: any = {
        username: role_id ? "" : getUsernameLocal()
    };
    if (role_id) {
        body.role_id = role_id;
    } else if (currentRoleId && currentRoleId !== "undefined") {
        body.role_id = Number(currentRoleId);
    }

    // logsPath("POST", get_role_permission);
    const response = await front_api("POST", get_role_permission, body, { wrapData: false });

    if (!response) {
        console.error("Cant fetch permissions");
        return false;
    }

    try {
        const result = await response.json();
        console.log(result);

        const base64Encoded = result.data.module_tree;
        const jsonStr = atob(base64Encoded);
        const moduleTree = JSON.parse(jsonStr);

        const result_perm = {
            "success": result.data.success,
            "data": moduleTree,
            "message": result.data.message || result.message || ""
        };

        // ป้องกัน overwrite เมื่อดูสิทธิ์ของ role อื่น (เช่น ใน Role Management)
        const isOwnRole = !role_id || String(role_id) === String(currentRoleId);
        if (isOwnRole) {
            savePermTree(base64Encoded);
            saveSignaturePermTree(result.data.signature);
        }

        console.log(result_perm)
        return result_perm;
    } catch (e) {
        console.error(e);
        return false;
    }
}

export const getModuleList = async () => {
    // logsPath("POST", get_module_tree);
    const response = await front_api("POST", get_module_tree, {}, { wrapData: false });

    if (!response) return false;

    try {
        return await response.json();
    } catch (e) {
        console.error(e);
        return false;
    }
}

export const getMyModuleNames = async () => {
    const response = await front_api("GET", "/module-names", {}, { wrapData: false });
    if (!response) return false;
    try {
        return await response.json();
    } catch (e) {
        console.error(e);
        return false;
    }
}

export const getMainModuleList = async () => {
    // logsPath("POST", get_main_module_list);
    const response = await front_api("GET", get_main_module_list, {}, { wrapData: false });

    if (!response) return false;

    try {
        return await response.json();
    } catch (e) {
        console.error(e);
        return false;
    }
}

export const getRoleList = async () => {
    const response = await front_api("GET", get_all_roles, {}, { wrapData: false });

    if (!response) return false;

    try {
        return await response.json();
    } catch (e) {
        console.error(e);
        return false;
    }
}

// Module form holds parent_id and sort_order as strings (often "" when blank).
// The backend Marshmallow schema rejects "" for Integer fields, so we coerce
// before sending: parent_id "" → null (schema allows null); sort_order "" →
// drop the field so the server-side default of 0 kicks in.
const sanitizeModulePayload = (formData: any) => {
    const out: any = { ...formData };

    if (out.parent_id === "" || out.parent_id === undefined) {
        out.parent_id = null;
    } else if (typeof out.parent_id === "string") {
        const n = Number(out.parent_id);
        out.parent_id = Number.isFinite(n) ? n : null;
    }

    if (out.sort_order === "" || out.sort_order === undefined || out.sort_order === null) {
        delete out.sort_order;
    } else if (typeof out.sort_order === "string") {
        const n = Number(out.sort_order);
        if (Number.isFinite(n)) {
            out.sort_order = n;
        } else {
            delete out.sort_order;
        }
    }

    return out;
};

export const createModule = async (formData: any) => {
    const request = {
        ...sanitizeModulePayload(formData),
        username: getUsernameLocal(),
        user_id: getUserIdFromLocal(),
    };

    // logsPath("POST", create_module);
    const response = await front_api("POST", create_module, request, { wrapData: false });

    if (!response) return false;

    try {
        if (!response.ok) {
            const errData = await response.json();
            return { success: false, message: errData.details || errData.error || `เกิดข้อผิดพลาด (${response.status})` };
        }
        return await response.json();
    } catch (e) {
        console.error(e);
        return false;
    }
}

export const createRole = async (formData: any) => {
    const request = {
        ...formData,
        username: getUsernameLocal(),
        user_id: getUserIdFromLocal(),
    };

    // logsPath("POST", create_role_permission);
    const response = await front_api("POST", create_role, request, { wrapData: false });

    if (!response) return false;

    try {
        if (!response.ok) {
            const errData = await response.json();
            return { success: false, message: errData.details || errData.error || `เกิดข้อผิดพลาด (${response.status})` };
        }
        return await response.json();
    } catch (e) {
        console.error(e);
        return false;
    }
}

export const editModule = async (formData: any, moduleId: any) => {
    const fullpath = edit_module + moduleId;
    const request = {
        ...sanitizeModulePayload(formData),
        username: getUsernameLocal(),
        user_id: getUserIdFromLocal(),
    };

    // logsPath("PUT", edit_module);
    const response = await front_api("PUT", fullpath, request, { wrapData: false });

    if (!response) return false;

    try {
        if (!response.ok) {
            const errData = await response.json();
            return { success: false, message: errData.details || errData.error || `เกิดข้อผิดพลาด (${response.status})` };
        }
        return await response.json();
    } catch (e) {
        console.error(e);
        return false;
    }
}

export const editRole = async (formData: any) => {
    const request = {
        ...formData,
        username: getUsernameLocal(),
        user_id: getUserIdFromLocal(),
    };

    // logsPath("PUT", upsert_role_permission);
    const response = await front_api("PUT", upsert_role_permission, request, { wrapData: false });

    if (!response) return false;

    try {
        if (!response.ok) {
            const errData = await response.json();
            return { success: false, message: errData.details || errData.error || `เกิดข้อผิดพลาด (${response.status})` };
        }
        return await response.json();
    } catch (e) {
        console.error(e);
        return false;
    }
}

export const deleteModule = async (module_id: number) => {
    const fullPath = delete_module + module_id;
    const body = {
        module_id: module_id,
        username: getUsernameLocal(),
    };

    // logsPath("DELETE", delete_module);
    const response = await front_api("DELETE", fullPath, body, { wrapData: false });

    if (!response) return false;

    try {
        if (!response.ok) {
            const errData = await response.json();
            return { success: false, message: errData.details || errData.error || `เกิดข้อผิดพลาด (${response.status})` };
        }
        return await response.json();
    } catch (e) {
        console.error(e);
        return false;
    }
}